module.exports = __webpack_public_path__ + "img/share_token.24ff03f5.jpeg";